var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":"General Search","prepend-icon":"mdi-magnify","clearable":""},on:{"input":_vm.onSearchInput,"focus":_vm.clearFilters},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})
}
var staticRenderFns = []

export { render, staticRenderFns }